import civicWatchLogo from './civic watch logo.png';
import dhnLogo from './dhn-newlogo.jpg';
import aboutEwer from './about-ewer.png';
import avatar from './avatar.png';
import circleLoader from './circle-loader.svg';
import civicWatchLogoTransparent from './civic_watch_logo-transparent.png';
import civicWatchLogo2 from './civic-watch-logo.png';
import civicWatchMungo from './civicwatchMungo.png';
import logo from './the_mungo_png.png';
import logoYellow from './the_mungo_png_yellow.png';
import logo_180 from './the_mungo_180.png';
import reactLogo from './circle-loader.svg';
import dhnOldLogo from './dhnMungo.png';
import r0gLogo from './r0gMungo.png';
import dhnLogoTransparent from './dhn-newlogo-transparent.png';
import bg from './mungo_background.png';
import incidentsLegend from './incidents-legend.jpg';

export {
  civicWatchLogo,
  dhnLogo,
  aboutEwer,
  avatar,
  circleLoader,
  civicWatchLogo2,
  civicWatchLogoTransparent,
  civicWatchMungo,
  logo,
  logoYellow,
  reactLogo,
  dhnOldLogo,
  r0gLogo,
  dhnLogoTransparent,
  logo_180,
  bg,
  incidentsLegend,
};
